import { OptTheme } from "@optsol/react";
import { Colors } from "./colors";

export const theme: OptTheme = {
  light: {
    style: "soft",
    primary: Colors.gray4,
    primaryContrast: Colors.primary,
    secondary: Colors.secondary,
    secondaryContrast: Colors.white,
  },
};
